module.exports = __webpack_public_path__ + "img/logo_min.594fb674.png";